import {Box} from "@mui/material";
import * as React from "react";
import {useAppTranslation} from "../services/i18n";
import {JsonEmailMessage, JsonFileInfo} from "../generated-api";
import {previewHtml, renderFile} from "../helpers/files";

type Props = {
    email?: JsonEmailMessage;
    showRecipient?: boolean;
    /** Files not attached to the e-mail itself but offered behind its link (e.g. the safety rules). */
    linkedFileInfos?: JsonFileInfo[];
    /** Only the body, for texts which are not sent as an e-mail. */
    bodyOnly?: boolean;
}

export const EmailPreview = ({email, showRecipient, linkedFileInfos, bodyOnly}: Props) => {
    const t = useAppTranslation();

    return <div className={'email-header'}>
        {!bodyOnly && <table>
            <tbody>
            <tr>
                <th style={{width: '15%'}}>{t('Od')}</th>
                <td style={{width: showRecipient ? '35%' : '85%'}}>{email?.mailFromTitle}</td>
                {showRecipient && <th style={{width: '10%'}}>{t('Komu')}</th>}
                {showRecipient && <td style={{width: '40%'}} title={email?.mailToTitles?.join(', ')}>{!!email?.mailToTitles && (email.mailToTitles.length > 1
                    ? <>{email.mailToTitles[0]} + {email.mailToTitles.length - 1} {t('další')}</>
                    : email.mailToTitles?.[0])}</td>}
            </tr>
            <tr>
                <th>{t('Předmět')}</th>
                <td colSpan={showRecipient ? 3 : undefined}>{email?.subject}</td>
            </tr>
            {!!email?.attachFileInfos?.length && email.attachFileInfos.length > 0 && <tr>
				<th>{t('Příloha')}</th>
				<td  colSpan={showRecipient ? 3 : undefined} className={'file-list'}>{email.attachFileInfos.map((a, i) => {
                    return <span key={i}>{renderFile(a)}</span>;
                })}</td>
			</tr>}
            {!!linkedFileInfos?.length && <tr>
                <th>{t('V pozvánce')}</th>
                <td colSpan={showRecipient ? 3 : undefined} className={'file-list'} title={t('Soubory se e-mailem neposílají, jsou k dispozici na odkazu v něm')}>
                    {linkedFileInfos.map((a, i) => <span key={i}>{renderFile(a)}</span>)}
                </td>
            </tr>}
            </tbody>
        </table>}
        <Box component={'div'} className='html-preview'
            dangerouslySetInnerHTML={{__html: previewHtml(email?.body)}}/>
    </div>
}